import CustomTable from '../../../../elements/Table/CustomTable'
import React from 'react'

function MRNLinesList (props) {
  const { list, isUpdatable, fetch, fetching, onShow } = props

  const columns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'No',
      accessor: 'no',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Package', accessor: 'package.name' },
    { Header: 'Purchase', accessor: 'purchases.title' },
    { Header: 'Purchases Lines', accessor: 'purchasesLines.name' },
    { Header: 'Req', accessor: 'reqs.title' },
    { Header: 'Req Line', accessor: 'reqLine.name' },
    { Header: 'Sales', accessor: 'sales.title' },
    { Header: 'Sales Lines', accessor: 'salesLine.name' },
    { Header: 'units', accessor: 'unit' },
    {
      Header: 'Total unit', accessor: 'totalUnits', hideable: true,
      hideDefault: true,
    },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      columns={columns}
    />
  )
}

MRNLinesList.propTypes = {}
MRNLinesList.defaultProps = {}

export default MRNLinesList
